import update from 'immutability-helper'
import uniqueId from 'lodash/uniqueId'
import IndexDBWrapper from 'indexdbwrapper'
import * as actionTypes from '../actionTypes'
import { CreateVideoSequenceTrackWithM3U8Content, CreateTrack } from "../../util/EditUtil";


/**
 *  fileType
 *  0 ==> 视频
 *  1 ==> 图片
 */

const db = new IndexDBWrapper('materialList', 1, {
    onupgradeneeded(e) {
        const db = e.target.result
        db.createObjectStore('t1', {
            autoIncrement: true,
            keyPath: 'key',
        })
    },
})

// db.getAllMatching('t1').then(data => {
//     console.log(data);
// });

const DefaultState = {
    position: {
        left: 0,
        top: 0,
    },
    BoundingClientRect: null,
    db,
    editorManager: null,
    managerLoading: false,
    previewLoading: false,
    mainTrackGroup: null,
    mainInternalGroup: null,
    mainCompositeTrack: null,
    mainComposite: null,
    mainMediaBeforeDuration: {},//主轨道视频原时长
    isShow: false,
    isEnter: false,
    disableMove: true,
    maxDuration: 0,
    sdkLibReady: false,
    currentDrag: null,
    isShowMainTopLine: false,
    trackList: [],
    appendTrackListItemUpload: false,
    appendTrackListItemProcess: 0,
    appendTrackListItemName: '',
    allMaterialList: [],
    materialList: [],
    writeList: [],
    sourceList: [],
    cutToDrag: {
        left: 0,
        top: 0,
        isShow: false,
        index: -1,
    },
    specialEffects: [],
    audioList: [],
    filters: [],
    animations: [
        //视频动画
        [],
        [
            //循环
        ],
        [
            //出场
        ],
    ],

    effects: [],
    allSticker: [],
    hotSticker: [
        {
            id: 'sticker4',
            effectPath: '/material/sticker/tz4',
            imgSrc: '/img/StickerCoverImg/tz4.gif',
            duration: 10,
        },
    ],
    expressionSticker: [
        {
            id: 'sticker5',
            effectPath: '/material/sticker/tz5',
            imgSrc: '/img/StickerCoverImg/tz5.png',
            duration: 10,
        },
    ],
    trackAnimations: [[], [], []],
    textBubble: [],
    textAnimations: [[], [], []],
    backgroundList: [],
    isFull: true,
}

export type IDefaultState = typeof DefaultState
const saveMediaBeforeDuration = (state: IDefaultState, action) => {
    console.log(action)
}
const changePosition = (state: IDefaultState, action) => {
    let { payload } = action
    return update(state, {
        position: { $set: payload },
    })
}

const addStickerAction = (state: IDefaultState, action) => {
    let { payload } = action

    return update(state, {
        allSticker: { $push: payload.newList },
        allMaterialList: {
            $push: payload.list,
        },
    })
}

const addMaterialItemAction = (state: IDefaultState, action) => {
    let { payload } = action
    return update(state, {
        allMaterialList: {
            $push: payload,
        },
    })
}

const addFilterAction = (state: IDefaultState, action) => {
    let { payload } = action
    return update(state, {
        filters: { $push: payload.newList },
        allMaterialList: {
            $push: payload.list,
        },
    })
}

const addTextBubbleAction = (state: IDefaultState, action) => {
    let { payload } = action
    return update(state, {
        textBubble: { $push: payload.newList },
        allMaterialList: {
            $push: payload.list,
        },
    })
}

const addEffectsAction = (state: IDefaultState, action) => {
    let { payload } = action

    return update(state, {
        specialEffects: { $push: payload.newList },
        allMaterialList: {
            $push: payload.list,
        },
    })
}

const addAnimationAction = (state: IDefaultState, action) => {
    let { payload } = action

    return update(state, {
        animations: {
            [payload.selectClassify]: { $push: payload.newList },
        },
        allMaterialList: {
            $push: payload.list,
        },
    })
}

const addTextAnimationAction = (state: IDefaultState, action) => {
    let { payload } = action

    return update(state, {
        textAnimations: {
            [payload.selectClassify]: { $push: payload.newList },
        },
        allMaterialList: {
            $push: payload.list,
        },
    })
}

const addTrackAnimationAction = (state: IDefaultState, action) => {
    let { payload } = action

    return update(state, {
        trackAnimations: {
            [payload.selectClassify]: { $push: payload.newList },
        },
        allMaterialList: {
            $push: payload.list,
        },
    })
}

const addeffectssAction = (state: IDefaultState, action) => {
    let { payload } = action

    return update(state, {
        specialEffects: { $push: payload.newList },
        allMaterialList: {
            $push: payload.list,
        },
    })
}

const changeProperty = (state: IDefaultState, action) => {

    let {
        payload: { value },
        propertyName,
    } = action

    return update(state, {
        [propertyName]: { $set: value },
    })
}

const changeTrackListProperty = (state: IDefaultState, action) => {
    let {
        payload: { value },
        propertyName,
        index,
        payload,
    } = action
    let { trackList } = state
    if (typeof index !== 'undefined') {
        return update(state, {
            trackList: {
                [index]: {
                    [propertyName]: { $set: value },
                },
            },
        })
    } else {
        let newList = trackList.map((ele) => {
            if (ele.id === payload.id) {
                ele = payload
            }
            return ele
        })

        return update(state, {
            trackList: {
                $set: newList,
            },
        })
    }
}

const changeTrackListAllProperty = (state: IDefaultState, action) => {
    let { payload } = action

    return update(state, {
        trackList: {
            $set: [...payload],
        },
    })
}

const changeTrackListItem = (state: IDefaultState, action) => {
    let {
        payload: { data },
        index,
    } = action

    return update(state, {
        trackList: {
            [index]: { $set: data },
        },
    })
}
const segmentMainTrack = (state: IDefaultState, action) => {
    let {
        trackList,
        mainTrackGroup,
        editorManager,
        currentDrag,
        mainInternalGroup
    } = state,
        { currentDragItem, currentTime } = action.payload;
    let currentTrack = null;
    let currentIndex = -1
    trackList.map((track: any, index: number) => {
        if (track.id === currentDragItem.id) {
            currentTrack = track
            currentIndex = index
        }
    });

    let splitTime = currentTime - currentTrack.startTime;

    // 分割轨道
    let newSxTrack = mainInternalGroup.splitTrack(currentTrack.videoTrack.getTrackId(), splitTime);
    newSxTrack = window["SXEditManager"].toMediaTrack(newSxTrack);

    let totalDuration = currentTrack.duration;

    // 改变原轨道时长
    currentTrack.videoTrack.setDuration(splitTime)
    trackList[currentIndex].duration = splitTime

    if (currentTrack.videoDelegate) {
        currentTrack.videoDelegate.used();
    }
    console.log(currentDragItem, 'currentDragItemcurrentDragItemcurrentDragItem')
    // 追加一个轨道
    let data = {
        trackId: newSxTrack.getTrackId(),
        id: uniqueId('mainTrackGroup'),
        startTime: currentTime,
        duration: totalDuration - splitTime,
        videoTrack: newSxTrack,
        scale: currentTrack.scale,
        isShowCutToBox: false,
        videoDelegate: currentTrack.videoDelegate,
        type: 5,
        isMainTrack: true,
        rotation: currentTrack.rotation,
        editorManager,
        shotUrl: currentTrack.shotUrl,
    }
    //若该视频已经转过文字的，则分割后的视频仍然不允许转文字
    if (currentDragItem.isSplit) {
        data['isSplit'] = true
    }
    trackList.splice(currentIndex + 1, 0, data)
    mainInternalGroup.addTrack(data.videoTrack, currentTime);
    resetMainGroupDuration(state);

    // console.log("segment",trackList)
    let newState = state;
    if (data.videoDelegate) {
        let trackSource = {
            trackId: data.trackId,
            delegate: data.videoDelegate,
        }

        let material = {
            path: data.videoDelegate.sequenceString,
            url: currentDragItem.mp4_url,
            type: currentDragItem.type_id,
            category_id: currentDragItem.category_id,
        }
        let newTrackTime = {
            beginTime: data.videoTrack.getOffsetTime(),
            //原视频的长度
            duration: state.mainMediaBeforeDuration[currentDragItem['id']].duration 
            ? state.mainMediaBeforeDuration[currentDragItem['id']].duration : state.mainMediaBeforeDuration[currentDragItem['id']],

        }
        let beforeTrackTime = {
            endTime: splitTime,
            duration: currentDragItem['duration']
        }

        // console.log("push source list", trackSource)
        newState = update(state, {
            sourceList: {
                $push: [trackSource],
            },
            allMaterialList: {
                $push: [material]
            },
            mainMediaBeforeDuration: {
                [data.id]: {
                    $set: newTrackTime
                },
                [currentDragItem['id']]: {
                    $set: beforeTrackTime
                }
            }
        })
    }

    return update(newState, {
        trackList: {
            $set: trackList,
        }
    });
}

const mainTrackAppendItem = (state: IDefaultState, action) => {
    let { payload } = action
    let { currentDrag, trackList, mainComposite, mainCompositeTrack} = state

    if (currentDrag == null) {
        currentDrag = payload.currentDrag
    }
    let newState = null
    let data = {
        currentDrag,
        trackId: payload.videoTrack.getTrackId(),
        id: payload.id || uniqueId('mainTrackGroup'),
        startTime: payload.startTime,
        duration: currentDrag.duration,
        videoTrack: payload.videoTrack,
        scale: payload.scale,
        isShowCutToBox: false,
        videoDelegate: payload.videoDelegate,
        type: 5,
        isSplit: payload.isSplit,//根据该字段区分视频是否转过字幕的视频段，如果为true，表示不可再次转字幕
        isMainTrack: true,
        shotUrl: currentDrag.shots_url || currentDrag.url,//图片要显示预览图URL
        rotation: payload.rotation,
        videoUrl: currentDrag.mp4_url
    }
    let len = trackList.length
    trackList = Object.assign([], trackList)

    if (currentDrag.type === 5 && Number(currentDrag.video_fps) === 0) {
        data.shotUrl = currentDrag.url
    }

    if (payload.index === -1 || payload.index === len - 1) {
        newState = update(state, {
            trackList: {
                $push: [data],
            },
        })
    } else if (payload.index === -2) {
        newState = update(state, {
            trackList: {
                $splice: [[0, 0, data]],
            },
        })
    } else {
        newState = update(state, {
            trackList: {
                $splice: [[payload.index + 1, 0, data]],
            },
        })
    }



    // 获取最大的编辑时长
    let maxDuration = 0
    let newLen = newState.trackList.length
    for (let i = 0; i < newLen; i++) {
        let currentItem = newState.trackList[i]
        let currentStartTime = currentItem.startTime + currentItem.duration
        if (currentStartTime >= maxDuration) {
            maxDuration = currentStartTime
        }
        currentItem.videoTrack.setStartTime(currentItem.startTime);
    }

    // 内部合成时间
    state.mainInternalGroup.arrangeTracks(true);
    let compositeMaxTime = state.mainComposite.getContentMaxTime(false);
    mainComposite.setDuration(compositeMaxTime);
    mainCompositeTrack.setDuration(compositeMaxTime);

    // editorManager 时间
    state.mainTrackGroup.arrangeTracks(true);
    let duration = newState.editorManager.getContextMaxTime(false);//true ,排除音频时长 ，false不排除

    if (duration < maxDuration) {
        newState.editorManager.setDuration(maxDuration);
    }
    let newTrackTime = null

    //预览图需要的开始时间，若新增则无需存beginTime
    if (payload.isShowBeginTime) {
        newTrackTime = {
            beginTime: payload.startTime,
            duration: currentDrag.duration
        }
    } else {
        newTrackTime = data.duration
    }
    return update(newState, {
        maxDuration: { $set: maxDuration },
        mainMediaBeforeDuration: {
            [data.id]: {
                $set: newTrackTime
            }
        },
    })
}

const changeTrackListItemPosition = (state: IDefaultState, action) => {
    let {
        payload: { index, isBefore, selfIndex },
    } = action
    let { mainTrackGroup, editorManager } = state
    let newState = null
    let data = state.trackList[selfIndex]
    let len = state.trackList.length
    if (selfIndex === len - 1 && index === len - 2 && isBefore) {
        return state
    }

    if (selfIndex > index) {
        if (isBefore) {
            index++
        }
        let spliceItem = state.trackList[index]
        data.startTime = spliceItem.startTime
        data.videoTrack.setStartTime(spliceItem.startTime)

        newState = update(state, {
            trackList: {
                $splice: [[index, 0, data]],
            },
        })

        newState.trackList.splice(selfIndex + 1, 1)
        let trackList = newState.trackList
        let len = newState.trackList.length
        for (let j = index + 1; j < len; j++) {
            let currentItem = trackList[j]
            if (j <= selfIndex) {
                currentItem.startTime += data.duration
                currentItem.videoTrack.setStartTime(currentItem.startTime)
            }
        }

        editorManager.draw(true, false, -1)
        return newState
    }

    return state

    // if (isBefore) {
    //     index++;
    // }

    // newState = update(state, {
    //     trackList: {
    //         $splice: [[index, 0, data]]
    //     }
    // });

    // spliceBeforeState = update(newState, {
    //     trackList: {
    //         $splice: [[index + 1, 1]]
    //     }
    // });

    // let trackList = spliceBeforeState.trackList;

    // for (let j = index + 1; j < trackList.length; j++) {
    //     let currentItem = trackList[j];
    //     let startTime = currentItem.startTime + currentDrag.duration;
    //     console.log(currentItem);
    // }

    // return spliceBeforeState;
}

const appendTrackListItem = (state: IDefaultState = DefaultState, action) => {
    let { payload } = action

    return update(state, {
        materialList: {
            $set: [...payload.data],
        },
    })
}

const SaveAudioList = (state: IDefaultState = DefaultState, action) => {
    let { payload } = action

    return update(state, {
        audioList: {
            $push: payload.data.currentList,
        },
        allMaterialList: {
            $push: payload.data.list,
        },
    })
}

const appendWriteItem = (state: IDefaultState = DefaultState, action) => {
    let { payload } = action
    return update(state, {
        writeList: {
            $push: payload.data.currentList,
        },
        allMaterialList: {
            $push: payload.data.list,
        },
    })
}

const appendSourceItem = (state: IDefaultState = DefaultState, action) => {
    let { payload } = action
    return update(state, {
        sourceList: {
            $push: payload.data,
        },
        mainMediaBeforeDuration: {

        }
    })
}

const changCutToDragProps = (state: IDefaultState = DefaultState, action) => {
    let {
        payload: { data },
    } = action


    return update(state, {
        cutToDrag: { $set: data },
    })
}

const appendSpecialEffectsListItem = (
    state: IDefaultState = DefaultState,
    action
) => {
    let {
        payload: { data },
    } = action
    let newData = {
        id: uniqueId('effectsItem'),
        ...data,
    }

    return update(state, {
        specialEffects: {
            $push: [newData],
        },
    })
}

const findCanAddCutTo = (state: IDefaultState = DefaultState, action) => {
    let {
        payload: { status },
    } = action
    let { trackList } = state

    let newTrackList = trackList.map((ele, index) => {
        // console.log("---", status, ele);
        if (status) {
            if (trackList[index + 1]) {
                ele.isShowCutToBox = true
            }
        } else {
            !ele.videoTrack.hasTransition() && (ele.isShowCutToBox = false)
        }
        return ele
    })

    return update(state, {
        trackList: { $set: newTrackList },
    })
}

const getSpecialEffect = (id: string, list: any) => {
    for (let i = 0; i < list.length; i++) {
        if (list[i]["id"] == id) {
            return list[i];
        }
    }
    return null;
}

const resetMainGroupDuration = (state) => {
   let { mainComposite, mainInternalGroup, mainCompositeTrack} = state
   let dur = mainComposite.getContentMaxTime(false);
   mainComposite.setDuration(dur);
   mainCompositeTrack.setDuration(dur)
}

const addCutTo = (state: IDefaultState = DefaultState, action) => {
    let {
        payload: { track },
    } = action,
        SXResource = window['SXResource'],
        kTransition = window['SXResourceType']['kTransition'],
        { trackList, specialEffects, cutToDrag, mainInternalGroup } = state

    let effect = getSpecialEffect(cutToDrag["id"], specialEffects);
    let newTrackList = trackList.map((ele, index) => {
        if (ele.id === track.id) {
            let s = new SXResource(kTransition, effect.effectPath)
            let transitionDuration = 3;
            // console.log("transition duration", effect, transitionDuration);
            ele.videoTrack.setTransition(s, transitionDuration)
            ele.isShowCutToBox = true
        } else {
            ele.isShowCutToBox = !!ele.videoTrack.hasTransition()
        }
        return ele
    })

    mainInternalGroup.arrangeTracks(true);
    resetMainGroupDuration(state);

    let newTrackList1 = newTrackList.map((ele, index) => {
        ele.duration = ele.videoTrack.getDuration()
        ele.startTime = ele.videoTrack.getDisplayTime()
        return ele
    })
    let newTrackList2 = newTrackList1.map((ele, index) => {
        let currentDuration = ele.startTime + ele.duration
        let nextEle = newTrackList1[index + 1]
        // if (nextEle) {
        //     if (currentDuration >= nextEle.startTime) {
        //         let offset = currentDuration - nextEle.startTime
        //         ele.duration -= offset
        //     }
        // }
        return ele
    })

    // console.log(newTrackList2);

    return update(state, {
        trackList: { $set: newTrackList2 },
    })
}

const correctPosition = (state: IDefaultState = DefaultState, action) => {
    let {
        payload: { index, duration },
    } = action
    let { trackList } = state
    let currentDragItem = trackList[index]
    let offset = currentDragItem.duration - duration

    let newTrackList = trackList.map((ele, selfIndex) => {
        if (selfIndex > index) {
            ele.startTime -= offset
        }
        return ele
    })

    return update(state, {
        trackList: { $set: newTrackList },
    })
}

const changeMainGroupMaxDuration = (state: IDefaultState = DefaultState) => {
    let { mainTrackGroup } = state,
        duration = mainTrackGroup.getDuration(false) || 0
    return update(state, {
        maxDuration: { $set: duration },
    })
}

const deleteSource = (trackId, sourceList, state) => {
    let list = []
    sourceList.map((source, index) => {
        if (source.trackId == trackId) {
            source.delegate.unused();
            source.delegate.release()
            sourceList.splice(index, 1)
        } else {
            list.push(source)
        }
    })

    update(state, {
        sourceList: { $set: list },
    })
}

const removeMainTrack = (state: IDefaultState = DefaultState, action) => {
    let {trackList, editorManager, sourceList, 
        mainComposite, mainInternalGroup, mainCompositeTrack } = state,
        {
            payload: { data, replacBeforeTrack },
        } = action,
        index = -1
    trackList.map((ele, selfIndex) => {
        if (ele.id === data.id) {
            index = selfIndex
            data = ele
        }
        return ele
    })
    let newTrackList = trackList.map((ele, selfIndex) => {
        //之前是删除重新计算，有了拆条后原有轨道的startTime不会改变
        if (!replacBeforeTrack) {
            if (ele.startTime + ele.duration > data.startTime + data.duration) {
                ele.startTime -= data.duration
            }
        }
        return ele
    })

    let adjoinTrack = newTrackList[index + 1] || newTrackList[index - 1]

    if (adjoinTrack) {
        let currentDeleteTrack = newTrackList[index]

        if (currentDeleteTrack && (currentDeleteTrack.isShowCutToBox || adjoinTrack.isShowCutToBox)) {
            currentDeleteTrack.isShowCutToBox = adjoinTrack.isShowCutToBox =
                false
            adjoinTrack.duration = adjoinTrack.videoTrack.getDuration()
        }
    }

    mainComposite.deleteTrack(data.trackId)
    newTrackList.splice(index, 1)


    deleteSource(data.trackId, sourceList, state)
    let newData = update(state, {
        trackList: { $set: newTrackList },
    })
    mainInternalGroup.arrangeTracks(true);
    let duration = mainComposite.getContentMaxTime(false) || 0

    mainComposite.setDuration(duration);
    mainCompositeTrack.setDuration(duration);
    editorManager.draw(true, false, -1)


    return update(newData, {
        maxDuration: { $set: duration },
    })
}

const addBackground = (state: IDefaultState = DefaultState, action) => {
    let {
        payload: { data },
    } = action

    data.id = uniqueId('background-')

    return update(state, {
        backgroundList: {
            $push: [data],
        },
    })
}

const updateMainTrackDuration = (state: IDefaultState = DefaultState) => {
    let { trackList, mainTrackGroup } = state


    mainTrackGroup.arrangeTracks(true);
    let newTrackList = trackList.map((ele) => {
        ele.duration = ele.videoTrack.getDuration()
        ele.startTime = ele.videoTrack.getDisplayTime()
        return ele
    })
    return update(state, {
        trackList: { $set: newTrackList },
    })
}

const addLocalFile = (state: IDefaultState = DefaultState, action) => {
    /* 如果是动画 i 代表[ 入场 | 循环 | 出场 ], 否则为空 */
    let {
        payload: { fileList, type, i },
    } = action,
        list = state[type],
        newFileList = []

    if (
        type === 'filters' ||
        type === 'effects' ||
        type === 'specialEffects' ||
        type === 'allSticker' ||
        type === 'expressionSticker' ||
        type === 'hotSticker' ||
        type === 'textBubble'
    ) {
        fileList.forEach((fileItem) => {
            fileItem.id = uniqueId('localFileId-')
        })

        newFileList = [...list, ...fileList]
    }

    if (
        type === 'animations' ||
        type === 'trackAnimations' ||
        type === 'textAnimations'
    ) {
        fileList.forEach((fileItem) => {
            fileItem.id = uniqueId('localFileId-')
        })

        list[i] = [...list[i], ...fileList]
        newFileList = [...list]
    }

    return update(state, {
        [type]: { $set: newFileList },
    })
}

const appendTrackListItemActionUpload = (
    state: IDefaultState = DefaultState,
    action
) => {
    let { payload } = action

    return update(state, {
        appendTrackListItemUpload: {
            $set: payload.data.show,
        },
        appendTrackListItemProcess: {
            $set: payload.data.process,
        },
        appendTrackListItemName: {
            $set: payload.data.names,
        },
    })
}

export default (state: IDefaultState = DefaultState, action) => {
    switch (action.type) {
        case actionTypes.ADD_LOCAL_FILE:
            return addLocalFile(state, action)

        case actionTypes.CHANGE_TRACK_LIST_ITEM:
            return changeTrackListItem(state, action)

        case actionTypes.UPDATE_MAIN_TRACK_DURATION:
            return updateMainTrackDuration(state)

        case actionTypes.CHANGE_POSITION:
            return changePosition(state, action)

        case actionTypes.REMOVE_MAIN_TRACK:
            return removeMainTrack(state, action)

        case actionTypes.CHANGE_MAIN_TRACK_PROPERTY:
            return changeProperty(state, action)

        case actionTypes.CHANGE_TRACK_LIST_PROPERTY:
            return changeTrackListProperty(state, action)

        case 'changeTrackListAllProperty':
            return changeTrackListAllProperty(state, action)

        case actionTypes.CHANGE_TRACK_LIST_ITEM_POSITION:
            return changeTrackListItemPosition(state, action)

        case actionTypes.MAIN_TRACK_APPEND_ITEM:
            return mainTrackAppendItem(state, action)

        case actionTypes.APPEND_TRACK_LIST_ITEM:
            return appendTrackListItem(state, action)

        case actionTypes.APPEND_SPECIAL_EFFECTS_LIST_ITEM:
            return appendSpecialEffectsListItem(state, action)

        case actionTypes.CHANGE_CUT_TO_DRAG_PROPS:
            return changCutToDragProps(state, action)

        case actionTypes.FINDE_CAN_ADD_CUT_TO:
            return findCanAddCutTo(state, action)

        case actionTypes.ADD_CUT_TO:
            return addCutTo(state, action)

        case actionTypes.CORRECT_POSITION:
            return correctPosition(state, action)

        case actionTypes.CHANGE_MAIN_GROUP_MAX_DURATION:
            return changeMainGroupMaxDuration(state)

        case actionTypes.ADD_BACKGROUND:
            return addBackground(state, action)

        case 'appendTrackListItemActionUpload':
            return appendTrackListItemActionUpload(state, action)

        case 'SaveAudioList':
            return SaveAudioList(state, action)

        case 'addStickerAction':
            return addStickerAction(state, action)

        case 'addFilterAction':
            return addFilterAction(state, action)

        case 'addTextBubbleAction':
            return addTextBubbleAction(state, action)

        case 'addEffectsAction':
            return addEffectsAction(state, action)

        case 'addAnimationAction':
            return addAnimationAction(state, action)

        case 'addTextAnimationAction':
            return addTextAnimationAction(state, action)

        case 'addTrackAnimationAction':
            return addTrackAnimationAction(state, action)

        case 'addeffectssAction':
            return addeffectssAction(state, action)

        case 'addMaterialItemAction':
            return addMaterialItemAction(state, action)

        case 'appendWriteItem':
            return appendWriteItem(state, action)

        case 'appendSourceItem':
            return appendSourceItem(state, action)

        case 'segmentMainTrack':
            return segmentMainTrack(state, action)

        default:
            return state
    }
}
